import styled from "styled-components";

export const Img = styled.img`
  height: 16px;
  width: 16px;
  vertical-align: sub
`;
